// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Spinner-module-spinner {
  stroke: var(--text);
  width: 20px;
  height: 20px;
}

button.primary-button .Spinner-module-spinner {
  stroke: var(--text-button);
}

.Spinner-module-spinner > g {
  transform-origin: center;
  animation: Spinner-module-spinner_zKoa 2s linear infinite;
}

.Spinner-module-spinner > g > circle {
  stroke-linecap: round;
  animation: Spinner-module-spinner_YpZS 1.5s ease-in-out infinite
}

@keyframes Spinner-module-spinner_zKoa{
  100% {
    transform: rotate(360deg)
  }
}

@keyframes Spinner-module-spinner_YpZS {

  0% {
    stroke-dasharray: 0 150;
    stroke-dashoffset: 0;
  }

  47.5% {
    stroke-dasharray: 42 150;
    stroke-dashoffset: -16;
  }

  95%, 100% {
    stroke-dasharray: 42 150;
    stroke-dashoffset: -59;
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Spinner/Spinner.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,yDAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;;EAEE;IACE,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;AAEF","sourcesContent":[".spinner {\r\n  stroke: var(--text);\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\nbutton:global(.primary-button) .spinner {\r\n  stroke: var(--text-button);\r\n}\r\n\r\n.spinner > g {\r\n  transform-origin: center;\r\n  animation: spinner_zKoa 2s linear infinite;\r\n}\r\n\r\n.spinner > g > circle {\r\n  stroke-linecap: round;\r\n  animation: spinner_YpZS 1.5s ease-in-out infinite\r\n}\r\n\r\n@keyframes spinner_zKoa{\r\n  100% {\r\n    transform: rotate(360deg)\r\n  }\r\n}\r\n\r\n@keyframes spinner_YpZS {\r\n\r\n  0% {\r\n    stroke-dasharray: 0 150;\r\n    stroke-dashoffset: 0;\r\n  }\r\n\r\n  47.5% {\r\n    stroke-dasharray: 42 150;\r\n    stroke-dashoffset: -16;\r\n  }\r\n\r\n  95%, 100% {\r\n    stroke-dasharray: 42 150;\r\n    stroke-dashoffset: -59;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var spinner = `Spinner-module-spinner`;
export var spinner_zKoa = `Spinner-module-spinner_zKoa`;
export var spinner_YpZS = `Spinner-module-spinner_YpZS`;
export default ___CSS_LOADER_EXPORT___;
